import React, { useLayoutEffect, useEffect, useRef, useState } from "react"
import Layout from "../components/layout"
import TransitionLink from 'gatsby-plugin-transition-link'
import { gsap } from "gsap";
import VisibilitySensor from 'react-visibility-sensor'
import { Link } from "gatsby"
import ReactPlayer from 'react-player'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { StaticImage } from "gatsby-plugin-image"
import Footer from "../components/footer"
import PjmGlance from "../components/pjm-glance"
import useWindowSize from "../hooks/useWindowDimensions"
import VideoSrc from "../videos/Sprint1_Welcome_3Pillars_DESKTOP.mp4"
import VideoSrcMobile from "../videos/Sprint1_Welcome_3Pillars_MOBILE.mp4"
import arrowLeft from "../images/yellow-arrow.svg"
import nextImage from "../images/Hero_05_Reliability_Resilience.jpg"
import prevImage from "../images/Hero_04_Operations_REV.jpg"
import nextRings from "../images/RINGS_BLUE_MAGENTA.svg"
import prevRings from "../images/RINGS_MAGENTA_YELLOW.svg"
import chevronDown from "../images/angle-down.svg"
import MarketsSVG from "../components/markets-svg"
import ringsgy from "../images/RINGS_GREEEN_YELLOW.svg"
import ringsmy from "../images/RINGS_MAGENTA_YELLOW.svg"
import ringscy from "../images/RINGS_CYAN_YELLOW.svg"
import ringsbm from "../images/RINGS_BLUE_MAGENTA.svg"
import ringsby from "../images/RINGS_BLUE_YELLOW.svg"


import "../components/pages.scss"

gsap.registerPlugin(ScrollTrigger);

const MarketsPage = (props) => {
    const size = useWindowSize();
    const firstRow = useRef();
    const circles = useRef([]);
    const navList = useRef();
    const [desktopViewState, setDesktopViewState] = useState(null);

    useLayoutEffect(() => {
        console.log(circles);
        for(let x = 0; x < circles.current.length; x++) {
            gsap.to(circles.current[x], {
                x: (i, target) => -1000 * target.dataset.speed,
                ease: "none",
                scrollTrigger: {
                    trigger: circles.current[x],
                    scrub: true,
                }
            });
        }

        gsap.from(firstRow.current, { y: 200, ease: "power2"});
        gsap.from(navList.current, {
            y: "-100%",
            duration: .35,
            ease: "power2"
        });
    }, []);

    return (
        <Layout>
            <main className="page markets">
                <title>Markets Page</title>
                <div className="row nav">
                    <div className="col-xs-12">
                        <nav>
                            <ul ref={navList}>
                                <li>
                                    <Link
                                        className="back-button"
                                        activeClassName="active"
                                        to="/"
                                        state={{ pageId: 4 }}
                                    >
                                        <img src={arrowLeft} alt=""/>
                                    </Link>
                                </li>
                                <li className="blue-bar">|</li>
                                <li data-url="markets" className="text--yellow">Markets</li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div className="page-set">
                    <div className="wrapper">
                        <div className="container">
                            <section className="panel">
                                <div className="wrap">
                                    <div className="profile" data-scroll data-scroll-speed="0">
                                        <StaticImage loading="eager" objectFit="contain" placeholder="blurred" quality="50" className="avatar" src="../images/Hero_09_Markets.jpg" alt="" />
                                        <img className="rings" src={ringsby} alt="" /> 
                                    </div>
                                    <div className="info">
                                        <div data-scroll data-scroll-speed="3" className="title--super text--outline">DRIVING
                                    </div>
                                        <h1 data-scroll data-scroll-speed="2">EFFICIENCY</h1>
                                        <div className="button-wrap">
                                            <TransitionLink
                                                className="button"
                                                to="/"
                                            >
                                                Read Lorem
                                            </TransitionLink>
                                        </div>
                                    </div>
                                    <img className="chevron-down" src={chevronDown} alt="" /> 
                                </div>
                                <div
                                    ref={(element) => circles.current[0] = element} 
                                    className="circle--green top p-7"
                                    data-speed=".2"
                                ></div>
                                <div
                                    ref={(element) => circles.current[1] = element} 
                                    className="circle--blue top p-7"
                                    data-speed="-.2"
                                ></div>
                                <div
                                    ref={(element) => circles.current[2] = element} 
                                    className="circle--pink top p-7"
                                    data-speed="-.1"
                                ></div>
                            </section>
                        </div>
                    </div>
                </div>
                <div className="row row-wrapper first-row content" ref={firstRow}>
                    <div className="col-xs-12">
                        <p className="text text--large text--bold">PJM has an international reputation as a leader in managing the world's largest, most advanced competitive wholesale markets for trading electricity and related products and services. Our markets generate an average $45 billion annually in transactions. </p>
                        <p className="text text--large text--bold">PJM's competitive markets are enabling an efficient transition to a decarbonized grid while maintaining reliability, helping to support and integrate growing amounts of renewable and demand-side management resources to the region.</p>
                        <h5 className="text--uppercase">Capacity Market Helps Ensure Reliable Performance</h5>
                        <p className="text">PJM's annual capacity auction requires participants to commit generating resources three years in advance of their needed performance in exchange for payment based on the outcome of the auction process. </p>
                        <p className="text">To ensure the PJM capacity market adequately incentivizes reliable performance in the energy market, PJM established Capacity Performance Resource rules in 2014. </p>
                        <p className="text">For the 2020/2021 Delivery Year ending on May 31, 2021, PJM did not declare any Performance Assessment Intervals. As a result, no Capacity Performance Resource was assessed a nonperformance charge.</p>
                        <h5 className="text--uppercase">Capacity Auction Resumes</h5>
                        <p className="text">The Base Residual Auction (BRA) is an important tool in procuring the generation resources required for reliability. PJM conducted the capacity market auction for the 2022/2023 Delivery Year in May and posted results in June. The auction cleared 144,477 MW of resources at a total cost of $3.9 billion. Total procured capacity represented a 19.9% reserve margin.</p>
                    </div>
                </div>
                <MarketsSVG />
                <div className="row row-wrapper">
                    <div className="col-xs-12">
                        <h5 className="text--uppercase">Capacity Market Reform</h5>
                        <p className="text">In response to direction from FERC (Federal Energy Regulatory Commission) in March, the PJM Board of Managers, PJM and stakeholders implemented a collaborative expedited process to explore reform of the Minimum Offer Price Rule (MOPR) necessary to better accommodate state energy policies. By June, stakeholders overwhelmingly supported the PJM proposal to apply the MOPR only to resources connected to buyer-side market power or those receiving state subsidies that hinged on clearance of the capacity auction. Approval by the PJM Board of Managers marked the first time in PJM history of the use of the Critical Issue Fast Path stakeholder process. In October, FERC approved an accelerated capacity market auction schedule through 2024.</p>
                    </div>
                </div>
                <div className="quote-wrap bg-blue sec-pad">
                    <div className="row row-wrapper content">
                        <div className="col-xs-12">
                            <div className="p-t-40 p-b-40">
                                <div className="row row-wrapper content max--1024">
                                    <div className="col-xs-12 text--center">
                                        <p className="text text--yellow text--large quote-text">&#8220;The capacity market is an integral part of facilitating the transition to a cleaner, smarter grid while maintaining reliable service.&#8221;</p>
                                        <p className="text text--yellow text--uppercase text--large quote-name">Stu Bresler, Senior Vice President – Market Services</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    ref={(element) => circles.current[3] = element} 
                    className="circle--blue page-1"
                    data-speed="-.1"
                ></div>
                <div className="row row-wrapper content">
                    <div className="col-xs-12">
                        <h5 className="text--uppercase m-t-60">Resource Adequacy Senior Task Force</h5>
                        <p className="text">A second, comprehensive phase of capacity market reform kicked off in 2021 with the formation of the interdisciplinary work of the Resource Adequacy Senior Task Force (RASTF).</p>
                        <p className="text">In this senior task force, PJM and stakeholders considered aspects of market reform related to assuring reliability and highlighted focus areas for review and discussion to improve the capacity market amid significant resource mix changes.</p>
                        <p className="text">The work of this "central clearinghouse" task force may overlap with topics elsewhere at PJM. By year's end, this task force identified ten key work activities for focus and collaboration. These actions ranged from considering the procurement of clean resource attributes to the updating of reliability metrics, performance assessments and incentives, resource accreditation and market power mitigation. The work of the RASTF is expected to be completed late next year for implementation by the capacity auction for the 2027/2028 Delivery Year.</p>
                        <h5 className="text--uppercase">Quadrennial Review</h5>
                        <p className="text">No less often than every fourth delivery year, PJM is required to review the shape of the Variable Resource Requirement (VRR) curve, calculation of the Cost of New Entry (CONE), and methodology for determining the Energy & Ancillary Services (E&AS) revenue offset. The last Quadrennial Review was completed in 2018. PJM initiated special sessions of the Market Implementation Committee in August 2021. All of the meetings from August through December 2021 were dedicated to education and soliciting stakeholder feedback earlier in the process than past reviews. The Quadrennial Review work will be completed in 2022, with a member vote by Aug. 31, followed by a FERC filing by Oct. 1.</p>
                    </div>
                </div>
                <div className="quote-wrap bg-blue sec-pad">
                    <div className="row row-wrapper content">
                        <div className="col-xs-12">
                            <div className="p-t-40 p-b-40">
                                <div className="row row-wrapper content max--1024">
                                    <div className="col-xs-12 text--center">
                                        <p className="text text--yellow text--large quote-text">&#8220;PJM has been analyzing the needs of the future grid and the reliability attributes that will be required of our resources to maintain reliability. It's critical that the rules, processes and practices of our operations, planning and market functions are all working together to incentivize, prepare for and manage a more flexible fleet as the grid evolves. The RASTF is the foundation for that essential work.&#8221;</p>
                                        <p className="text text--yellow text--uppercase text--large quote-name">Adam Keech, Vice President – Market Design & Economics</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row row-wrapper content">
                    <div className="col-xs-12">
                        <h5 className="text--uppercase m-t-60">Fast-Start Pricing</h5>
                        <p className="text">FERC accepted PJM's compliance filing on proposed rules for fast-start resources in May 2021. This resulted in amendments to the PJM Operating Agreement to define a fast-start resource and stipulate how those resources can set energy prices. Fast-start pricing was successfully implemented on Sept. 1, 2021.</p>
                        <h5 className="text--uppercase">Five-Minute Dispatch and Pricing</h5>
                        <p className="text">PJM and the Independent Market Monitor concluded a collaborative effort to better align dispatch signals and associated pricing on Nov. 1, 2021, with the implementation of Real-Time Security Constrained Economic Dispatch (RT SCED) application updates. The RT SCED application, which is used by PJM system operators to reliably dispatch resources throughout the PJM RTO, was updated to shorten the dispatch look-ahead period from 10 minutes to five minutes while also aligning system pricing and the five-minute dispatch instructions. This effort also included significant updates to the PJM Tariff and Manuals, improving transparency for the benefit of market participants.</p>
                        <h5 className="text--uppercase">Financial Transmission Rights Market</h5>
                        <p className="text">The ARR/FTR Market Task Force (AFMTF) – formed to conduct a comprehensive review of the ARR/FTR Market design, including allocation of congestion rights, FERC objectives, value proposition and opportunities for enhancements – concluded in December. The result was a stakeholder consensus and FERC approval on enhancements that are expected to provide increased value to market participants through better utilization of the transmission system and increased transparency.</p>
                    </div>
                </div>
            </main>
            <Footer 
                nextLink="/reliability" 
                nextImage={nextImage}
                nextText="Next &gt;"
                nextTitle="Reliability & Resilience"
                nextButton="" 
                nextRings={nextRings}
                prevLink="/operations" 
                prevImage={prevImage}
                prevText="&lt; Previous"
                prevButton=""
                prevTitle="Operations"  
                prevRings={prevRings} 
            />
        </Layout>
    )
}

export default MarketsPage